import { fetchIfLoggedIn } from '../utils.js'
import * as actions from 'actions'
import { isResourceProfile } from '../../routes/admin/ResourcesManager/ProfileManagement/utils.js'

export const fetchAppSettings = appContainerId => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.FETCH_APP_ITSM_SETTINGS,
      method: 'get',
      path: `/apps/${appContainerId}/advanced-settings`,
    })
  )
}

export const createAppSettings = (appContainerId, values) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.CREATE_APP_ITSM_SETTINGS,
      method: 'post',
      path: `/apps/${appContainerId}/advanced-settings`,
      postBody: values,
    })
  )
}

export const updateAppSettings = (appContainerId, values) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.UPDATE_APP_ITSM_SETTINGS,
      method: 'put',
      path: `/apps/${appContainerId}/advanced-settings`,
      postBody: values,
    })
  )
}

export const fetchProfileSettings = papId => dispatch => {
  const path = isResourceProfile()
    ? `/resource-manager/profile/${papId}/advanced-settings`
    : `/paps/${papId}/advanced-settings`
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.FETCH_PROFILE_ITSM_SETTINGS,
      method: 'get',
      path: path,
    })
  )
}

export const createProfileSettings = (papId, values) => dispatch => {
  const path = isResourceProfile()
    ? `/resource-manager/profile/${papId}/advanced-settings`
    : `/paps/${papId}/advanced-settings`
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.CREATE_PROFILE_ITSM_SETTINGS,
      method: 'post',
      path: path,
      postBody: values,
    })
  )
}

export const updateProfileSettings = (papId, values) => dispatch => {
  const path = isResourceProfile()
    ? `/resource-manager/profile/${papId}/advanced-settings`
    : `/paps/${papId}/advanced-settings`
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.UPDATE_PROFILE_ITSM_SETTINGS,
      method: 'put',
      path: path,
      postBody: values,
    })
  )
}
